module.exports = __webpack_public_path__ + "img/王敏.9f293157.jpg";